import {
  type FieldValues,
  type UseControllerProps,
  useController,
} from 'react-hook-form';
import { OptInput, type OptInputProps } from '../Inputs/OtpInput';
import { useRules } from './hooks';

export type OptFieldV2Props<T extends FieldValues> = UseControllerProps<T> &
  Omit<OptInputProps, 'value' | 'defaultValue'> & {
    required?: boolean;
  };

export function OtpFieldV2<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  required,
  ...props
}: OptFieldV2Props<T>) {
  const innerRules = useRules({ required, ...rules });

  const { field, fieldState } = useController<T>({
    name,
    control,
    defaultValue,
    rules: innerRules,
    shouldUnregister,
  });

  return <OptInput {...field} {...props} error={fieldState.error?.message} />;
}
